import React, { useState, useRef } from 'react';
import { fadeIn, fadeOut } from '../utils/functions';

export default function Share(props) {
  const { url } = props;
  const [isOpen, setIsOpen] = useState(false);
  const shareList = useRef(null);
  const shareOpen = useRef(null);

  /*
   *
   * Set style depending on right side distance
   *
   */
  var isStyleInverse = false;
  if (shareOpen?.current) {
    var distance = window.innerWidth - shareOpen.current.getBoundingClientRect().right;
    if (distance < 200) {
      isStyleInverse = true;
    }
  }

  /*
   *
   * Handlers
   *
   */
  const handleShareClick = e => {
    let el = e.target;
    if (window.matchMedia('(min-width: 768px)')) {
      isOpen ? setIsOpen(false) : setIsOpen(true);
      if (el.classList.contains('open')) {
        fadeOut(shareList.current);
      } else {
        fadeIn(shareList.current);
      }
    }
  };
  const handleClose = () => {
    if (window.matchMedia('(min-width: 768px)')) {
      setIsOpen(false);
      fadeOut(shareList.current);
    }
  };

  /*
   *
   * Platform Options to Share
   *
   */
  const shareOptions = [
    {
      title: 'twitter',
      svg: (
        <svg width='16' height='13' viewBox='0 0 16 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M15.3332 0.999868C14.6948 1.45019 13.9879 1.79461 13.2398 2.01987C12.8383 1.55821 12.3047 1.231 11.7112 1.08249C11.1177 0.933975 10.4928 0.971332 9.92122 1.1895C9.34961 1.40768 8.8588 1.79614 8.51516 2.30235C8.17152 2.80856 7.99164 3.40809 7.99984 4.01987V4.68653C6.82826 4.71691 5.66735 4.45708 4.62051 3.93017C3.57367 3.40325 2.67338 2.62562 1.99984 1.66653C1.99984 1.66653 -0.666829 7.66653 5.33317 10.3332C3.96019 11.2652 2.32461 11.7325 0.666504 11.6665C6.6665 14.9999 13.9998 11.6665 13.9998 3.99987C13.9992 3.81417 13.9814 3.62893 13.9465 3.44653C14.6269 2.77553 15.1071 1.92834 15.3332 0.999868Z'
            fill='white'
          />
        </svg>
      ),
      url: `https://twitter.com/intent/tweet?url=${url}&hasthags`,
    },
    {
      title: 'facebook',
      svg: (
        <svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M7.99996 0.333252H5.99996C5.1159 0.333252 4.26806 0.684441 3.64294 1.30956C3.01782 1.93468 2.66663 2.78253 2.66663 3.66659V5.66659H0.666626V8.33325H2.66663V13.6666H5.33329V8.33325H7.33329L7.99996 5.66659H5.33329V3.66659C5.33329 3.48977 5.40353 3.32021 5.52855 3.19518C5.65358 3.07016 5.82315 2.99992 5.99996 2.99992H7.99996V0.333252Z'
            fill='white'
          />
        </svg>
      ),
      url: `https://www.facebook.com/sharer/sharer?u=${url}`,
    },
    {
      title: 'whatsapp',
      svg: (
        <svg width='16' height='16' viewBox='-23 -21 682 682.66669' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0'
            fill='white'
          />
        </svg>
      ),
      url: `https://wa.me/?text=${url}`,
    },
  ];

  return (
    <div className='card-law__share'>
      <span className={`card-law__share-open${isOpen ? ' open' : ''}`} data-share-open onClick={handleShareClick} ref={shareOpen}></span>

      <div className={`card-law__share-list${isStyleInverse ? ' inverse' : ''}`} data-share-list ref={shareList}>
        <ul>
          {shareOptions.map((eachOne, i) => {
            return (
              <li key={'shareOptions_' + shareOptions[i].title + '_' + i} onClick={handleClose}>
                <a href={shareOptions[i].url} target='_blank' rel='noreferrer'>
                  {shareOptions[i].svg}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
